<template>
  <div class="containerStart">
    <canvas ref="canvas"></canvas>
    <!-- <a href="#" class="warp-btn" @click.prevent="toggleWarp">Switch style and speed</a> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      numStars: 3000,
      radius: '0.' + (Math.floor(Math.random() * 9) + 1),
      focalLength: 0,
      warp: 0,
      animate: true,
      stars: [],
      c: null,
      centerX: 0,
      centerY: 0
    }
  },

  mounted() {
    this.initCanvas()
    window.addEventListener('resize', this.handleResize)
    this.executeFrame()
  },

  beforeDestroy() {
    this.animate = false
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
      this.c = canvas.getContext('2d')
      this.initializeStars()
    },

    initializeStars() {
      this.centerX = this.$refs.canvas.width / 2
      this.centerY = this.$refs.canvas.height / 2
      this.focalLength = this.$refs.canvas.width * 2
      this.stars = Array.from({ length: this.numStars }, () => ({
        x: Math.random() * this.$refs.canvas.width,
        y: Math.random() * this.$refs.canvas.height,
        z: Math.random() * this.$refs.canvas.width,
        o: '0.' + (Math.floor(Math.random() * 99) + 1)
      }))
    },

    moveStars() {
      this.stars.forEach(star => {
        star.z -= 2
        if (star.z <= 0) star.z = this.$refs.canvas.width
      })
    },

    drawStars() {
      if (this.$refs.canvas.width !== window.innerWidth ||
        this.$refs.canvas.height !== window.innerHeight) {
        this.initCanvas()
        return
      }

      if (this.warp === 0) {
        this.c.fillStyle = 'rgba(0,10,20,1)'
        this.c.fillRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
      }

      this.stars.forEach(star => {
        const pixelX = (star.x - this.centerX) * (this.focalLength / star.z) + this.centerX
        const pixelY = (star.y - this.centerY) * (this.focalLength / star.z) + this.centerY
        const pixelRadius = 0.8 * (this.focalLength / star.z)
        this.c.fillStyle = `rgba(255, 200, 108, ${star.o})`
        this.c.fillRect(pixelX, pixelY, pixelRadius, pixelRadius)
        this.c.fillStyle = `rgba(255, 255, 255, 0.15)`
        this.c.fillRect(pixelX - 2, pixelY - 2, pixelRadius + 4, pixelRadius + 4)
      })
    },

    executeFrame() {
      if (!this.animate) return
      requestAnimationFrame(this.executeFrame)
      this.moveStars()
      this.drawStars()
    },


    handleResize() {
      this.initCanvas()
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border-style: none;
}

.containerStart {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 999;
  background-color: #000;
}

canvas {
  display: block;
  background: black;
  position: absolute;
  top: 0;
  left: 0;
}

</style>